import { useEffect } from "react";

const usePhonePeCheckout = (tokenUrl, callback, isPaymentStarted) => {
  useEffect(() => {
    if (!isPaymentStarted || !tokenUrl) return; // Only proceed if payment has started and tokenUrl is available

    // Function to load the PhonePe script
    const loadPhonePeScript = () => {
      return new Promise((resolve, reject) => {
        const scriptId = "phonepe-checkout-script";
        const existingScript = document.getElementById(scriptId);

        if (existingScript) {
          resolve(); // Script is already loaded
          return;
        }

        const script = document.createElement("script");
        script.src = "https://mercury.phonepe.com/web/bundle/checkout.js";
        script.id = scriptId;
        script.onload = resolve;
        script.onerror = () => reject(new Error("PhonePe script load failed"));
        document.body.appendChild(script);
      });
    };

    const initiatePhonePePayment = async () => {
      try {
        await loadPhonePeScript();
        if (window.PhonePeCheckout) {
          // Call PhonePeCheckout transaction function
          window.PhonePeCheckout.transact({
            tokenUrl, // URL to generate the payment token
            callback, // Callback to handle the payment response
            type: "IFRAME", // Use IFRAME or POPUP as required
          });
        } else {
          console.error("PhonePeCheckout is not defined after script load.");
        }
      } catch (error) {
        console.error("Error loading PhonePe script:", error);
      }
    };

    initiatePhonePePayment();
  }, [tokenUrl, callback, isPaymentStarted]); // Only run when tokenUrl, callback, or isPaymentStarted changes
};

export default usePhonePeCheckout;
